import React, { useState } from 'react';
import { OverlayTrigger, Popover } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { usePermission } from '../../../helpers/common';
import { logout } from '../../../actions/auth';
import { logoutFB } from '../../../helpers/fb';
import { Avatar, Icon } from '../../widgets';
import avatar from "../../../../assets/images/avatar.png";

const ProfileMenu = (props) => {
    const { showNotificationSetting } = props;
    const [show, setShow] = useState(false);

    const history = useHistory();
    const dispatch = useDispatch();
    const allow = usePermission();

    const isSettingsEnabled = true;

    const userInfo = useSelector(state => state.auth.userInfo);
    const farmId = useSelector(state => state.farm.currentFarm.farm_uuid);

    const isAllowView = allow("settings", "view");

    const list = [
        // { value: 'notification', label: "Notification Settings", icon: "fa fa-bell" },
        { value: 'settings', label: "Settings", icon: "fa fa-cog", visible: isAllowView },
        // { value: 'sms configurations', label: "SMS Configurations", icon: "fa fa-exclamation-circle" },
        { value: 'logout', label: "Logout", icon: "fa fa-sign-out", className: "logout", visible: true },
    ];

    const handleClick = async (item) => {
        setShow(false);
        if (item.value === 'notification') showNotificationSetting();
        else if (item.value === 'settings') history.push(`/home/farm/${farmId}/settings`);
        else if (item.value === 'sms configurations') history.push(`/home/farm/${farmId}/message/alert`);
        else if (item.value === 'logout') {
            await logoutFB();
            dispatch(logout());
        }
    };

    const popover = <Popover className='profile-popover'>
        <Popover.Content>
            <div>
                {list.filter((e) => e.visible).map((item, i, data) => {
                    return (
                        <div key={i} >
                            {data.length > 1 && item.value === 'logout' && <div className='divider' />}
                            <div className={`cursor-pointer labels-list ${item.className ? item.className : ""}`}
                                style={{ cursor: !isSettingsEnabled && item.value === 'settings' ? "not-allowed" : "pointer" }}
                                title={!isSettingsEnabled && item.value === 'settings' ? "Permission Denied" : ""}
                                onClick={!isSettingsEnabled && item.value === 'settings' ? null : () => handleClick(item)}>
                                <span className='mr-2 ml-2' disabled={isSettingsEnabled ? false : true}><Icon className={item.icon} /></span>
                                {item.label}
                            </div>
                        </div>);
                })}
            </div>
        </Popover.Content>
    </Popover>;

    return (
        <div className="profile-menu">
            <OverlayTrigger
                show={show}
                onToggle={toggle => setShow(toggle)}
                trigger="click"
                placement="bottom-end"
                delay={{ show: 1000 }}
                overlay={popover} >
                <Avatar
                    className="profile-header cursor-pointer"
                    name={userInfo.loginId}
                    singleLetterAvatar={true}
                    src={avatar}
                />
            </OverlayTrigger>
        </div>
    );
};

export default ProfileMenu;